import React from 'react';
import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';
import PropTypes from 'prop-types';
import { StarRating } from '../StarRating';

const PROP_TYPES = {
  rating: PropTypes.number,
  reviewCount: PropTypes.number,
  reviewLink: PropTypes.string,
};

const ReviewAreaNoLink = styled.div`
  margin-bottom: ${theme.spacingLg};
  font-weight: ${theme.fontWeightSemibold};
`;

const ReviewAreaLink = ReviewAreaNoLink.extend`
  display: block;
  text-decoration: none;
  color: ${theme.colorBrandPrimary};
  transition: color 0.15s ease-out;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: ${theme.colorLink};
  }
`.withComponent('a');

const RatingContainer = styled.div`
  line-height: 1;
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacingSm};
`;

const RatingNumber = styled.span`
  color: ${theme.colorBrandOrange};
  font-weight: ${theme.fontWeightSemibold};
  font-size: ${theme.fontSizeMd};
`;

const AppReview = ({ rating, reviewCount, reviewLink }) => {
  const reviewInner = (
    <>
      <RatingContainer>
        <StarRating rating={rating ? rating : 0} numStars={5} />
        {Boolean(reviewCount) && (
          <RatingNumber>{rating.toFixed(1)}</RatingNumber>
        )}
      </RatingContainer>
      {reviewCount && reviewCount > 0 ? reviewCount : 'No'} Reviews
    </>
  );
  {
    return reviewLink ? (
      <ReviewAreaLink href={reviewLink}>{reviewInner}</ReviewAreaLink>
    ) : (
      <ReviewAreaNoLink>{reviewInner}</ReviewAreaNoLink>
    );
  }
};

AppReview.propTypes = PROP_TYPES;
AppReview.displayName = 'StarRating';

export { AppReview };
